import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Cgu } from '../pages/Cgu';
import { Cookie } from '../pages/Cookie';
import { Home } from '../pages/Home';
import { PrivacyPolicy } from '../pages/PrivacyPolicy';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/gestion_des_cookies" element={<Cookie />} />
        <Route path="/conditions_generales_utilisation" element={<Cgu />} />
        <Route path="/politique_de_confidentialite" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
};
